export const ACTION_PREFIX = 'UI';
export const STATE_NAME = 'ui';

export const Actions = {
  DISPLAY_MOBILE_NAV: `${ACTION_PREFIX}/DISPLAY_MOBILE_NAV`,
  HIDE_MOBILE_NAV: `${ACTION_PREFIX}/HIDE_MOBILE_NAV`,
  SET_MEDIA_BREAKPOINTS: `${ACTION_PREFIX}/SET_MEDIA_BREAKPOINTS`,
  SET_DEVICE: `${ACTION_PREFIX}/SET_DEVICE`,
};

export const ScreenSize = {
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
};

export const BreakPoints = {
  [ScreenSize.XS]: 0,
  [ScreenSize.SM]: 34, // 544px
  [ScreenSize.MD]: 48, // 768px
  [ScreenSize.LG]: 62, // 992px
  [ScreenSize.XL]: 75, // 1200px
};

export const BreakPointsNext = {
  [ScreenSize.XS]: 0,
  [ScreenSize.SM]: 37.5, // 600px
  [ScreenSize.MD]: 60, // 960px
  [ScreenSize.LG]: 80, // 1280px
  [ScreenSize.XL]: 120, // 1920px
};

export const ImageGeometry = {
  ORIGINAL: 'original',
  LARGE: 'large',
  LARGE_RETINA: 'large-retina',
  TINY: 'tiny',
  TINY_RETINA: 'tiny-retina',
};
